import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

// Barra de abas interna do módulo Relatórios (/reports e /relatorio-vendas),
// no mesmo padrão do CampaignsNav (sublinhado em gradiente na aba ativa).
// Sem checagem de permissão: as duas rotas já são protegidas pelo menu/rota.
const useStyles = makeStyles((theme) => {
  const isLight = theme.palette.type === "light";
  return {
    tabsBar: {
      display: "flex",
      gap: 2,
      flexShrink: 0,
      borderBottom: `1px solid ${
        isLight ? theme.palette.divider : "rgba(255,255,255,0.08)"
      }`,
      marginBottom: theme.spacing(2),
    },
    tab: {
      appearance: "none",
      background: "none",
      border: "none",
      borderBottom: "2px solid transparent",
      cursor: "pointer",
      fontFamily: "inherit",
      padding: "10px 18px",
      fontSize: 13,
      fontWeight: 500,
      color: theme.palette.text.secondary,
      "&:hover": {
        color: theme.palette.text.primary,
      },
    },
    tabActive: {
      fontWeight: 700,
      color: theme.palette.text.primary,
      borderBottom: "2px solid",
      borderImage: "linear-gradient(90deg,#A044FF,#22D3EE) 1",
    },
  };
});

const TABS = [
  { to: "/reports", key: "tickets" },
  { to: "/relatorio-vendas", key: "reasons" },
  { to: "/reports/api", key: "api" },
];

const ReportsNav = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();

  const isActive = (to) =>
    location.pathname === to ||
    (to !== "/reports" && location.pathname.startsWith(`${to}/`));

  return (
    <nav className={classes.tabsBar} aria-label={i18n.t("aeros.reportsNav.aria")}>
      {TABS.map(({ to, key }) => (
        <button
          key={to}
          type="button"
          className={`${classes.tab} ${isActive(to) ? classes.tabActive : ""}`}
          aria-current={isActive(to) ? "page" : undefined}
          onClick={() => {
            if (!isActive(to)) history.push(to);
          }}
        >
          {i18n.t(`aeros.reportsNav.${key}`)}
        </button>
      ))}
    </nav>
  );
};

export default ReportsNav;
